import { getWindowGlobal } from './browserRuntime';

const denyUrls = [
  // Chrome extensions
  /^chrome:\/\//i,
  /chrome-extension:/i,
  /extensions\//i,

  // Locally saved copies
  /file:\/\//i,

  // Safari extensions.
  /safari-web-extension:/i,
  /safari-extension:/i,
];

const ignoreErrors = [
  'ResizeObserver loop completed with undelivered notifications',
];

export const initializeSentry = async (Vue) => {
  const errorLoggingConfig = getWindowGlobal('errorLoggingConfig');

  if (!errorLoggingConfig) {
    return null;
  }

  try {
    const [Sentry, { Integrations }] = await Promise.all([
      import(/* webpackChunkName: "sentry" */ '@sentry/vue'),
      import(/* webpackChunkName: "sentry" */ '@sentry/tracing'),
    ]);

    Sentry.init({
      Vue,
      dsn: errorLoggingConfig,
      denyUrls,
      integrations: [new Integrations.BrowserTracing()],
      ignoreErrors,
    });

    return Sentry;
  } catch {
    return null;
  }
};
